var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoEveryMatrix = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.1932 0 0 11.1932 0 25C0 38.8068 11.1932 50 25 50C38.8068 50 50 38.8068 50 25C49.9939 11.1932 38.8007 0 25 0ZM17.2325 44.7912C13.5747 46.6903 7.63312 42.5073 3.96312 35.4421C0.287005 28.3708 0.280899 21.1041 3.93869 19.2049C7.59648 17.3058 13.5381 21.4888 17.2081 28.554C20.8781 35.6192 20.8903 42.892 17.2325 44.7912ZM10.3078 9.64216C10.3078 4.75696 16.8845 0.799951 25 0.799951C33.1155 0.799951 39.6922 4.75696 39.6922 9.64216C39.6922 14.5274 33.1155 18.4844 25 18.4844C16.8845 18.4844 10.3078 14.5274 10.3078 9.64216ZM27.9983 45.0049C24.1023 42.0616 24.9023 34.4284 29.7875 27.9494C34.6727 21.4766 41.799 18.6065 45.6949 21.5498C49.5909 24.4932 48.7909 32.1263 43.9057 38.6053C39.0144 45.0843 31.8942 47.9482 27.9983 45.0049ZM34.7643 8.42697L32.4072 10.4971L27.7418 7.6148L27.6258 11.0405L22.3986 10.9245L26.6121 13.5259L23.6932 15.4555L14.3014 9.84978L16.4692 8.43307L23.4917 8.32316L23.4978 4.94626L26.3495 3.08378L34.7643 8.42697Z",
    fill: "#23B04E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoEveryMatrix);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_every_matrix.7c656c9f3a386e4192eb6a53e32b0229.svg";